import { Alert, Box, Button } from "@mui/material";
import React from "react";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        gap: 5,
      }}
    >
      <Alert severity="error">Oops! something went wrong</Alert>
      <Button onClick={resetErrorBoundary}>Go Home</Button>
      <Alert severity="error">{error.message}</Alert>
    </Box>
  );
};

export default ErrorFallback;
